import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  private readonly notifications = inject(NotificationService);

  /**
   * Number of in-flight requests. Tracked as a count rather than a flag so that
   * one request finishing does not hide the bar while others are still running.
   */
  private pendingRequests = 0;
  private readonly _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$: Observable<boolean> = this._loading.pipe(distinctUntilChanged());

  showProgressBar(loading: boolean): void {
    this.pendingRequests = loading
      ? this.pendingRequests + 1
      : Math.max(0, this.pendingRequests - 1);

    this._loading.next(this.pendingRequests > 0);
  }

  displayMessage(
    message: string,
    dismissText: string = 'Ok',
    durationSeconds: number = 4,
    position: 'top' | 'bottom' = 'bottom',
  ) {
    this.notifications.show(message, durationSeconds * 1000, dismissText, position);
  }
}
